import { createContext, useContext } from "react";

/**
 * What an empty card means (mockup screen 14): with filters set, "no matching
 * items" (offer Clear filters); without, an observed zero. AppShell provides it
 * from the page's filters; a card reads it through useEmptyContext().
 */
export const EmptyContext = createContext({ filtered: false, clear: null });

export const useEmptyContext = () => useContext(EmptyContext);
